var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookSingleLayer = function SvgFacebookSingleLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "-38 -40 340 340"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m178.55 164.27 5.71-35.71h-34.28v-25c0-10 3.57-17.86 19.28-17.86h16.43V52.85C176.4 51.42 166.41 50 157.11 50c-29.28 0-50 17.86-50 50v28.57H74.99v35.71h32.12V255a108.2 108.2 0 0 0 42.85 0v-90.7Z",
    fill: "#0c1e34"
  })));
};
export default SvgFacebookSingleLayer;